function init() {
	const contacts = document.querySelector('.contacts');

	if (contacts) {
		const checkbox = contacts.querySelector('.login__form > .checkbox');
		const checkboxContents = contacts.querySelectorAll('.contacts__login-container');

		checkbox.addEventListener('change', () => {
			checkboxContents.forEach((item) => {
				item.classList.toggle('d-block');
			});
		});
	}

	const payments = document.querySelectorAll('.payment');

	if (payments) {
		payments.forEach((item) => {
			const checkboxs = item.querySelectorAll('.payment__method > .checkbox > .checkbox__input');

			checkboxs.forEach((it) => {
				it.addEventListener('change', () => {
					checkboxs.forEach((el) => {
						el.checked = false;
					});
					it.checked = true;
				});
			});
		});
	}

	const selectAge = document.querySelector('.select--age');

	if (selectAge) {
		let selectAgeBtn = selectAge.querySelector('.select__btn');
		let selectAgeTitle = selectAge.querySelector('.select__btn-title');
		let selectAgeList = selectAge.querySelector('.select__list');
		let selectAgeListItems = selectAge.querySelectorAll('.select__list > .select__list-item');

		selectAgeBtn.addEventListener('click', () => {
			selectAgeList.classList.toggle('d-block');
			selectAge.classList.toggle('active');
		});

		selectAgeListItems.forEach((item) => {
			item.addEventListener('click', () => {
				selectAgeTitle.textContent = item.textContent;
				selectAgeList.classList.toggle('d-block');
				selectAge.classList.toggle('active');
			});
		});

		document.addEventListener('click', (e) => {
			const withinBoundaries = e.composedPath().includes(selectAge);

			if (!withinBoundaries) {
				selectAgeList.classList.remove('d-block');
				selectAge.classList.remove('active'); // скрываем элемент т к клик был за его пределами
			}
		});
	}

	const selectBranch = document.querySelector('.select--branch');

	if (selectBranch) {
		let selectBranchBtn = selectBranch.querySelector('.select__btn');
		let selectBranchTitle = selectBranch.querySelector('.select__btn-title');
		let selectBranchList = selectBranch.querySelector('.select__list');
		let selectBranchListItems = selectBranch.querySelectorAll('.select__list > .select__list-section');

		selectBranchBtn.addEventListener('click', () => {
			selectBranchList.classList.toggle('d-block');
			selectBranch.classList.toggle('active');
		});

		selectBranchListItems.forEach((item) => {
			item.addEventListener('click', () => {
				selectBranchTitle.textContent = item.getAttribute('data-city');
				selectBranchList.classList.toggle('d-block');
				selectBranch.classList.toggle('active');
			});
		});

		document.addEventListener('click', (e) => {
			const withinBoundaries = e.composedPath().includes(selectBranch);

			if (!withinBoundaries) {
				selectBranchList.classList.remove('d-block');
				selectBranch.classList.remove('active'); // скрываем элемент т к клик был за его пределами
			}
		});
	}
}

export default {
	init,
};
